import ZendeskWidget from './ZendeskWidget';

export default ZendeskWidget;
